import {useNavigate, useSearchParams} from 'react-router-dom';
import React, {useEffect, useRef, useState} from 'react';
import {SendUnauthenticatedRpc} from '../../rpcSender';
import {useAuth0} from '@auth0/auth0-react';
import {WelcomeToKensu} from "./WelcomeToKensu";
import {useProfile} from "../../UserProfileProvider";
import {CheckInvitationRequest, CheckInvitationResponse, ICheckInvitationResponse} from "../../compiled";
import {RpcState} from "../../util/RpcState";
import { App2 } from '../App2';

/**
 * This page does not require authentication. It checks that the invite code is
 * valid and shows a splash page if so. Then the user is prompted to sign in,
 * and that returns to the /redeem path in order to redeem the invite and associate
 * the new account with the login.
 */
export const CheckUserInvite = () => {


  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('inviteCode');

  const {loginWithRedirect} = useAuth0();
  const {profile} = useProfile();
  const navigate = useNavigate();

  const rpcSent = useRef(false);

  // This login redirects back to the redeem invite page...
  const auth0Login = () => {
    loginWithRedirect({
      appState: {
        returnTo: `/redeem?inviteCode=${inviteCode}`
      },
      authorizationParams: {
        audience: `https://narwhal.kenko.space/`,
        scope: 'openid offline_access' // to get refresh token
      }
    });
  }

  // if the rpc is out
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [rpcResponse, setRpcResponse] = useState<ICheckInvitationResponse>();

  // The effect for checking an invite code; this only happens if there is no authenticated user.
  useEffect(() => {

    // This invite only goes out if there's an invite code and it's been confirmed that
    // there is no authenticated user. This then checks whether the invite is valid.
    if (!inviteCode || profile || rpcState.state != 'none') {
      return;
    }
    
    if (rpcSent.current) {
      console.log('not resending check_invite')
      return;
    }

    setRpcState({state: 'pending'})
    rpcSent.current = true;

    let request = CheckInvitationRequest.encode(new CheckInvitationRequest({
      inviteCode: inviteCode,
    })).finish();

    SendUnauthenticatedRpc('action/check_invite', request).then(r => {
      let response = CheckInvitationResponse.decode(r);
      if (response.okay) {
        setRpcState({state: 'success'});
      } else {
        setRpcState({state: 'error', message: 'Server error checking invite.'});
      }
      setRpcResponse(response);
    }).catch(e => {
      console.log(e);
      setRpcState({state: 'error', message: 'Network error checking invite. Please try again later'});
    });

  }, [inviteCode]);

  // If this user already has a profile, redirect to the home screen. This can happen
  // if they've clicked the old redeem link from their email to find kensu.
  useEffect(() => {
    if (profile) {
      navigate('/')
    }
  }, [profile]);

  if (rpcState.state == 'pending') {
    return <App2>
      <div style={{padding: 100}}>Looking up your invite...</div>
    </App2>
  }

  if (rpcState.state == 'success') {
    return <App2>
        <div className='SurveyInfoPage'>
          <h2>Welcome to Kensu!</h2>
          <div>We’re excited to join you on your wellness journey.
            To start, please create a log in and answer a few questions
            to help us customize your experience.
          </div>
          <div>
            <button className={'ActionButton'} onClick={auth0Login}>Get started</button>
          </div>
        </div>
    </App2>
  }

  return <App2>
    <div className={'ErrorText'} style={{padding: 100}}>
      Error checking invite code. it may be invalid or expired
    </div>
  </App2>;

}
